import OaApiService from './OaApiService';

export default class ReviewService extends OaApiService {
  getAgentReviews(agentKey) {
    return new Promise((resolve, reject) => {
      this.get('/ReviewREST/agent-reviews', {}, agentKey)
        .then((reviews) => {
          resolve(reviews);
        })
        .catch((error) => {
          if (error === 'No reviews found') {
            resolve([]);
          } else {
            reject(error);
          }
        });
    });
  }
}
